<template>
  <div>
    <vxe-grid
      ref="techTable"
      auto-resize
      resizable
      highlight-hover-row
      :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
      :data="tableData"
      :columns="tableColumns"
      :height="500"
      size="mini"
      border
      row-id="pdTechDictCode"
      :edit-config="{ enabled: true, trigger: 'click', mode: 'row' }"
      @edit-closed="editClosed"
      :edit-rules="rules"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="top"
        >
          <i class="el-icon-delete tool-btn" @click="$emit('remove', row)"></i>
        </el-tooltip>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import { format, multiplyRound } from '@/libs/util.number.js'
export default {
  props: { tableData: { type: Array, default: () => [] } },
  data() {
    return {
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          align: 'center',
          fixed: 'left',
          width: 80,
          slots: { default: 'opt' },
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: '',
          field: 'pdProcessDictStep',
          width: 100,
          visible: false,
          sortable: true,
        },
        {
          title: this.$l('table_label_pdProcessDictStep') || '工序',
          field: 'v_pdProcessDictStep',
          width: 100,
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_techName') || '工艺',
          field: 'techName',
          minWidth: 150,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_techDesc') || '工艺说明',
          field: 'techDesc',
          minWidth: 200,
          headerAlign: 'center',
          align: 'left',
          editRender: {
            name: 'ElInput',
            props: {
              placeholder:
                this.$l('INDEX.tips_input_placeholder') || '请输入...',
              clearable: true,
            },
          },
          showHeaderOverflow: true,
        },
        {
          title: this.$l('table_label_techChargeUnit') || '计价单位',
          field: 'techChargeUnit',
          width: 100,
          align: 'center',
          editRender: {
            name: 'dict-select',
            props: {
              url: '/master/common/dict/biz',
              body: { dictType: 'techChargeUnit' },
              placeholder: this.$l('INDEX.tips_select_data') || '请选择...',
              filterable: true,
              clearable: true,
            },
          },
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_unitPrice') || '单价',
          field: 'unitPrice',
          align: 'center',
          width: 100,
          editRender: {
            name: 'ElInputNumber',
            props: {
              placeholder:
                this.$l('INDEX.tips_input_placeholder') || '请输入...',
              min: 0,
              precision: 4,
              controls: false,
            },
          },
          formatter: ({ row }) => {
            const { unitPrice: value } = row
            return format(value)
          },
          showHeaderOverflow: true,
        },
        {
          title: this.$l('table_label_qty') || '数量',
          field: 'qty',
          align: 'center',
          width: 100,
          editRender: {
            name: 'ElInputNumber',
            props: {
              placeholder:
                this.$l('INDEX.tips_input_placeholder') || '请输入...',
              min: 0,
              precision: 4,
              controls: false,
            },
          },
          formatter: ({ row }) => {
            const { qty: value } = row
            return format(value)
          },
          showHeaderOverflow: true,
        },
        {
          title: this.$l('table_label_subPrice') || '小计',
          field: 'subPrice',
          align: 'center',
          width: 100,
          formatter: ({ row }) => {
            const { subPrice } = row
            return format(subPrice)
          },
          showHeaderOverflow: true,
        },
      ],
      rules: {
        techChargeUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
          },
        ],
        unitPrice: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
        qty: [
          {
            type: 'number',
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
          },
          {
            validator: ({ cellValue }) => {
              if (!cellValue) {
                return new Error(this.$l('INDEX.tips_input_cannot_be_zero'))
              }
            },
          },
        ],
      },
    }
  },
  methods: {
    editClosed({ row }) {
      const { unitPrice, qty } = row
      row.subPrice = multiplyRound(unitPrice, qty)
    },
    async sort(sortConfs, order) {
      await this.$refs.techTable.sort(sortConfs, order)
    },
    async validate() {
      return !(await this.$refs.techTable.validate(true))
    },
    async getTableData() {
      const { tableData } = this.$refs.techTable.getTableData()
      return tableData || []
    },
  },
}
</script>
